import { render, staticRenderFns } from "./MultiselectBase.vue?vue&type=template&id=22ab38af&"
import script from "./MultiselectBase.vue?vue&type=script&lang=js&"
export * from "./MultiselectBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../opt/homebrew/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports